import React from 'react';
import { UploadingVideo } from '@/utils/optimistic/optimisticUpload';
import UploadingTile from '@/utils/dashboard/UploadingTile';

interface UploadingVideoTileProps {
  readonly uploadingVideo: UploadingVideo;
}

/**
 * Individual uploading video tile component
 * Used in virtualized grid to render uploading video tiles
 */
const UploadingVideoTile: React.FC<UploadingVideoTileProps> = ({
  uploadingVideo,
}) => {
  return (
    <UploadingTile
      status={uploadingVideo.status}
      progress={uploadingVideo.progress}
      aspectRatio="16/9"
    />
  );
};

export default UploadingVideoTile;
